import React from 'react';
import DekorInput from '../commons/DekorInput.jsx'
import GriffInput from '../commons/GriffInput.jsx'
import RadioGroup from '../commons/RadioGroup.jsx'
import Helper from "../../../model/Helper";
import SidebarFrame from "./SidebarFrame";

export default class TuerSettings extends SidebarFrame {

    state = {}

    renderTitle() {
        return I18N("Türen");
    }

    getSidebarParent() {
        return "tueren";
    }

    get tuer() {
        return this.props.model.vsData;
    }

    productChanged(artikelnummer) {
        const product = this.matchingDoors().find(p => p.Artikelnummer === artikelnummer);
        APP.model.tryCompile(() => {
            this.tuer.setFromProduct(product);
        });
    }

    matchingDoors() {
        const tuer = this.tuer;
        const element = tuer.element;
        const schrank = tuer.schrank;

        if (!element) {
            return [];
        }

        const elementSize = tuer.getElementBox(element).getSize();
        return APP.findProductsByType('Tuer').filter(x =>
            x.BreiteMax >= elementSize.x
            && x.BreiteMin <= elementSize.x
            //&& allowedSidesFromVerdeckung.test(productSide(x))
        );
    }


    renderBody() {
        const arrangement = APP.arrangement;
        const types = this.matchingDoors().map(product => ({
            value: product.Artikelnummer,
            label: product.Name,
            checked: this.tuer.product.Artikelnummer === product.Artikelnummer
        }));

        return (
            <div>
                <fieldset>
                    <legend>{I18N("Maße")}</legend>
                    <table>
                        <tbody>
                        <tr>
                            <td>{I18N("Höhe")}:</td>
                            <td>{Helper.formatNum(this.tuer.size.y)} cm</td>
                        </tr>
                        <tr>
                            <td>{I18N("Breite")}:</td>
                            <td>{Helper.formatNum(this.tuer.size.x)} cm</td>
                        </tr>
                        </tbody>
                    </table>
                </fieldset>

                <RadioGroup name={"type"} label={I18N("Türtyp")} onChange={value => this.productChanged(value)}
                            options={types}/>

                <DekorInput value={APP.getMaterialForVsData(this.tuer)} appear={true}
                            dekore={APP.getMaterialsForVsData(this.tuer)}
                            setValue={value=>APP.setMaterialForVsData(this.tuer,value)}
                            label={I18N("Welches Dekor wünschen Sie?")}/>

                <GriffInput value={APP.arrangement.griffArtikelnummer} setValue={APP.model.tryWrap(this,value=>APP.arrangement.griffArtikelnummer = value)}
                            label={I18N("Welche Griffe wünschen Sie?")}/>

                {this.tuer.isClosed &&
                <button className="button primary" onClick={() => {
                    APP.model.showDoorsClosed(false);
                    this.setState(this.state);
                }} href="#">{I18N("Öffnen")}</button>
                }
                {!this.tuer.isClosed &&
                <button className="button primary" onClick={() => {
                    APP.model.showDoorsClosed(true);
                    this.setState(this.state);
                }} href="#">{I18N("Schliessen")}</button>
                }
            </div>
        )
    }
}